<template>
	<div
		class="square-box"
		:class="[`square-box-${theme}`, { 'cursor-pointer': clickable }]"
		@click="handleClick()"
	>
		<div
			v-if="focused"
			class="square-box-focused tw-flex tw-justify-center tw-items-center"
		>
			<p class="content-name tw-m-0 tw-text-center">{{ name }}</p>
		</div>
		<div
			class="square-box-content tw-flex tw-justify-center tw-items-center"
			:class="[{ 'square-box-content-checked': checked }]"
		>
			<div>
				<check-icon class="check-icon" :color="checked ? 'success' : ''" />
			</div>
			<p class="content-name tw-m-0 tw-text-center">{{ name }}</p>
			<div v-if="displayActions" class="content-actions">
				<img
					:src="`${$imageUrl}/edit.svg`"
					class="tw-mr-4"
					@click="$emit('onEditClick')"
				/>
				<img
					:src="`${$imageUrl}/delete-button.svg`"
					class=""
					@click="$emit('onDeleteClick')"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import CheckIcon from '../icons/check-icon';

export default {
	name: 'SquareBox',
	components: { CheckIcon },
	props: {
		name: {
			default: () => '',
		},
		checked: {
			default: () => false,
		},
		focused: {
			default: () => false,
		},
		displayActions: {
			default: () => true,
		},
		theme: {
			default: () => 'primary',
		},
		clickable: {
			default: () => false,
		},
	},
	methods: {
		handleClick() {
			if (!this.clickable) return;
			this.$emit('click');
		},
	},
};
</script>

<style lang="scss" scoped>
.square-box {
	border-radius: 10px;
	box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
	background-color: #ffffff;
	padding-bottom: 90%;
	position: relative;
	user-select: none;

	&.square-box-primary {
		border: solid 2px var(--app-color-primary);
	}
	&.square-box-secondary {
		border: solid 2px var(--app-color-secondary);
		.square-box-content {
			&.square-box-content-checked {
				.content-name {
					color: var(--app-color-primary);
				}
			}
			.content-name {
				color: var(--app-color-secondary);
			}
		}
	}

	.square-box-focused,
	.square-box-content {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}

	.square-box-focused {
		z-index: 1;
		background: var(--app-color-primary);
		.content-name {
			color: #ffffff !important;
			font-size: 16px;
			padding: 0 10px;
			line-height: 16px;
		}
	}
	.square-box-content {
		padding: 20px 10px;
		text-align: center;
		.content-name {
			color: var(--app-color-primary);
			font-size: 14px;
			line-height: 14px;
		}
		.check-icon {
			position: absolute;
			top: 5px;
			right: 5px;
			width: 20px;
		}
		.content-actions {
			position: absolute;
			bottom: 5px;
			left: 0;
			right: 0;
			img {
				cursor: pointer;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/content/SquareBox.vue